var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SubAPI } from "./SubAPI";
var EmployeeAPI = /** @class */ (function (_super) {
    __extends(EmployeeAPI, _super);
    function EmployeeAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmployeeAPI.prototype.list = function (props) { return this.fetcher.get("/api/employees", props); };
    EmployeeAPI.prototype.listForAutoComplete = function (props) { return this.fetcher.get("/api/employees/auto-complete", props); };
    EmployeeAPI.prototype.logout = function () {
        window.location = "/api/auth/logout";
    };
    EmployeeAPI.prototype.login = function (input) { return this.fetcher.postForAuth("/api/auth/login", input); };
    EmployeeAPI.prototype.get = function (id) { return this.fetcher.get("/api/employee", { id: id }); };
    EmployeeAPI.prototype.create = function (employee) { return this.fetcher.post("/api/employee/create", employee); };
    EmployeeAPI.prototype.update = function (employee) { return this.fetcher.post("/api/employee/update", employee); };
    EmployeeAPI.prototype.setPassword = function (input) { return this.fetcher.post("/api/employee/set-password", input); };
    EmployeeAPI.prototype.initiateResetPassword = function (input) { return this.fetcher.post("/api/initiate-reset-password", input); };
    EmployeeAPI.prototype.completeResetPassword = function (input) { return this.fetcher.post("/api/complete-reset-password", input); };
    EmployeeAPI.prototype.removeWages = function (ids) { return this.fetcher.post("/api/employee-wage/remove", { ids: ids }); };
    EmployeeAPI.prototype.listWages = function (input) { return this.fetcher.get("/api/employee-wages", input); };
    EmployeeAPI.prototype.createWage = function (input) { return this.fetcher.post("/api/employee-wage", input); };
    EmployeeAPI.prototype.updateWage = function (input) { return this.fetcher.post("/api/employee-wage/update", input); };
    return EmployeeAPI;
}(SubAPI));
export { EmployeeAPI };
